import { ConfirmModal } from '@/components/ConfirmModal';

export interface FeatureIntroModalProps {
  open: boolean;
  title: string;
  confirmText: string;
  cancelText?: string;
  children?: React.ReactNode;
  onConfirm: () => void;
  onCancel: () => void;
  busy?: boolean;
  theme?: string;
}

/**
 * Thin wrapper over ConfirmModal for one-time "feature intro" prompts.
 *
 * Renders the feature's rich value-prop body (`children`) with a primary
 * confirm button (Enable) and a soft cancel ("Not now"). The actual
 * registry-driven content and imperative mounting live in
 * `src/services/feature-intro/`.
 */
export function FeatureIntroModal({
  open,
  title,
  confirmText,
  cancelText = 'Not now',
  children,
  onConfirm,
  onCancel,
  busy = false,
  theme,
}: FeatureIntroModalProps) {
  return (
    <ConfirmModal
      open={open}
      title={title}
      confirmText={confirmText}
      cancelText={cancelText}
      confirmClass="primary"
      autoFocus="confirm"
      busy={busy}
      theme={theme}
      onConfirm={onConfirm}
      onCancel={onCancel}
    >
      {children}
    </ConfirmModal>
  );
}
